// extracted by mini-css-extract-plugin
export default {"text1":"orderlink_text1__olCDP","link":"orderlink_link__8ZHb5"};